import React, { Fragment } from 'react';
import '../../Stylesheets/homeTab.css';

interface TabProps {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: TabProps[];
  activeTabIndex: number;
  onTabChange: (index: number) => void;
}

const Tabs = ({ tabs, activeTabIndex, onTabChange }: TabsProps) => (
    <div className="tabshome border-b border-[#E0DEF7] w-fit">
        {tabs.map((tab, index) => (
            <Fragment key={index}>
                <input type="radio" id={tab.id} name="tabs" />
                <label
                    className={`tabhome text-sm gap-2 font-semibold ${activeTabIndex === 0 && tab.id === 'rent' ? 'text-custom-lemongreen' : activeTabIndex === 1 && tab.id === 'buy' ? 'text-custom-lemongreen' : activeTabIndex === 2 && tab.id === 'coOwn' ? 'text-custom-lemongreen' : ''}`}
                    htmlFor={tab.id}
                    onClick={() => onTabChange(index)}
                >
                    {tab.label}
                </label>
            </Fragment>
        ))}
        <span className="gliderhome" style={{ transform: `translateX(${activeTabIndex * 100}%)` }} />
    </div>
);

export default Tabs;
